function showLoading() {
  let ajaxLoader = document.getElementById(`ajax-loader`);
  if (ajaxLoader) ajaxLoader.classList.add(`show`);
}

function hideLoading() {
  let ajaxLoader = document.getElementById(`ajax-loader`);
  if (ajaxLoader) ajaxLoader.classList.remove(`show`);

}

const ApiService = {

  loadJSON: (url, method = `get`, body) => {

    const headers = {
      'X-Requested-With': `XMLHttpRequest`,
    };

    if (body) {
      if (typeof body === `string`) {
        headers[`Content-Type`] = `application/x-www-form-urlencoded`;
      } else if (typeof body === `object`) { // json type
        headers[`Content-Type`] = `application/json`;
        body = JSON.stringify(body);
      }
    }

    if ([`POST`, `DELETE`, `PUT`].indexOf(method.toUpperCase()) >= 0) showLoading();

    return fetch(url, {
      credentials: `include`,
      headers,
      method,
      body,
    }).then(response => response.json())
      .then(responseData => {

        hideLoading();

        if (responseData.success) {
          return responseData.data;
        } else {
          throw new Error(responseData.error);
        }
      })
      .catch(() => {
        hideLoading();
      });
  },

  postFormData: (url, formData) => {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(`POST`, url, true);
      request.onload = () => {
        hideLoading();
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const json = JSON.parse(request.responseText);
          if (json.success) {
            resolve(json.data);
          } else {
            reject(new Error(json.error));
          }
        } else {
          reject(new Error(`Bad Status: ${request.status}, URL: ${url}, text:${request.responseText}`));
        }
      };

      request.onerror = () => {
        reject(new Error(`Cannot load URL: ${url}`));
      };

      request.send(formData);
      showLoading();
    });
  },

  uploadImages: (filesToUpload, temple, date) => {
    const formData = new FormData();
    for (let i = 0; i < filesToUpload.length; ++i) {
      formData.append(`image`, filesToUpload[i]);
    }

    date = date.replace(/-/g, `/`);
    return ApiService.postFormData(__API_URL__ + `/${temple}/${date}`, formData);
  },

};

export default ApiService;



// WEBPACK FOOTER //
// ./js/ApiService.js